import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../Partials/Footer";
import feather from "feather-icons";
import './chat.css'
import vector from "./vector.svg";
import { db } from "../firebase/firebase";
import Header from "../Partials/Header";
import { collection, addDoc, query, onSnapshot, orderBy, serverTimestamp, doc, where, getDocs } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from '../firebase/firebase';
import { Button, Card, Modal } from "react-bootstrap";


const Chats = () => {
  const navigate = useNavigate();
  const [isChatVisible, setIsChatVisible] = useState(false);
  const location = useLocation();
  const appointmentsRef = collection(db, "appointments");
  const appointmentId = location.state?.appId;
  const email = location.state?.email;
  const [appDetail, setAppDetail] = useState();
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [userGender, setUserGender] = useState("");
  const [userID, setUserId] = useState('');
  const [isUser, setIsUser] = useState('');
  const [appointmentStatus, setAppointmentStatus] = useState();
  const [imageUrls, setImageUrls] = useState({}); // Store image URLs
  const [currentStep, setCurrentStep] = useState(0)

  // Fetch messages for this user

  const handleGoBack = () => {
    navigate(-1); // This takes the user back to the previous page
  };

  const checkDeviceSize = () => {
    if (window.innerWidth <= 768) {
      var querySelect = document.querySelector("#scrollUp")
      if(querySelect){
        document.querySelector("#scrollUp").classList.add("d-none");
      }
      setIsChatVisible(true); // Set state to true when chat should be visible
    } else {
      setIsChatVisible(false); // Set state to false when chat should not be visible
    }
  };

  useEffect(() => {
    // Check device size on initial render
    checkDeviceSize();

    // Add event listener for window resize
    const handleResize = () => checkDeviceSize();
    window.addEventListener("resize", handleResize);

    feather.replace();
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);



  // const handleSendMessage = async () => {
  //   if (message.trim() === '') return;

  //   await addDoc(collection(db, 'messages', appointmentId, 'Chats'), {
  //     text: message,
  //     sender: 'user',
  //     timestamp: serverTimestamp.now(),
  //   });

  //   setMessage('');
  // };

  useEffect(() => {
    if (appointmentId) {
      fetchAppointment(appointmentId);
      // console.log(first)
    }
  }, [appointmentId]);

  const fetchAppointment = async (id) => {
    try {
      const q = query(appointmentsRef, where("appId", "==", id)); // Create a query to match ZBarDb
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const appointmentData = {
          id: querySnapshot.docs[0].id, // Include unique document ID
          ...querySnapshot.docs[0].data(),
        }; 
        // console.log("Appointment data:", appointmentData);
        setUserId(querySnapshot.docs[0].id)
        setAppDetail(appointmentData);
        setAppointmentStatus(appointmentData.status)
        // setUserGender(appointmentData.gender);
        // await getUserImageUrl(querySnapshot.docs[0].id, appointmentData.gender);

      }
      setLoading(false);
    } catch (error) {
      console.error(error)
    }finally{
      setLoading(false);
    }
  }

  useEffect(() => {
    if (userID) {
      const q = query(
        collection(db, `messages/${userID}/Chats`), // Ensure correct path
        orderBy('timestamp')
      );

      const unsubscribe = onSnapshot(q, (snapshot) => {
        const fetchedMessages = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMessages(fetchedMessages);
        // console.log(fetchedMessages);
      });

      return () => unsubscribe();
    }
  }, [userID]);



  // const getUserImageUrl = async (userId, gender) => {
  //   let imagePath = gender === 'male' ? `man.png` : `woman.jpeg`; // Default image path

  //   try {
  //     const imageRef = ref(storage, imagePath); // Create reference to the image in Firebase Storage
  //     const url = await getDownloadURL(imageRef); // Get the download URL
  //     setImageUrls(prev => ({ ...prev, [userId]: url })); // Store the URL in state
  //   } catch (error) {
  //     console.error("Error fetching image from storage", error);
  //   }
  // };

  const sendMessage = async () => {
    if (newMessage.trim() === "") return; // Prevent empty messages

    try {
      await addDoc(collection(db, `messages/${userID}/Chats`), {
        message: newMessage,
        senderId: userID, // Replace with dynamic sender ID if needed
        receiverId: "adminID",
        receiverName: "Sandhya Chinala",
        timestamp: serverTimestamp(),
        is_read: false,
      });
      setNewMessage(""); // Clear input field after sending
      setIsUser(userID)
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  return (
    <>
      <Header />
     
        {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent">
            <li className="breadcrumb-item">
              <a href="#" className="text-muted">
                Home
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              My Appointment
            </li>
          </ol>
        </nav> */}

        {loading && (
          <div className="text-center">
            <span className="spinner-border spinner-border-sm mt-5" role="status"></span>
          </div>
        )}
      {currentStep == 0 &&
        <div className="container pb-3 mt-2" >

          { !loading && (appDetail ?
            <Card className="appointment-card  m-3 shadow-sm" key={appointmentId} >
              <Card.Header as="h5" className="appointment-header">
                Appointment Details
              </Card.Header>
              <Card.Body className="appointment_card_body">
                <Card.Text>
                  <div className="detail-container">
                    <div className="detail-row">
                      <div className="detail-item">
                        <strong>Patient's Name:</strong> {appDetail?.name}
                      </div>
                    </div>
                    <div className="detail-row">
                      <div className="detail-item">
                        <strong>Status:</strong>
                        <span
                          className={` p-2 ${appDetail.status === 'pending'
                            ? 'badge badge-warning-soft fs-2'
                            : appDetail.status === 'accepted'
                              ? 'badge badge-info-soft fs-2'
                              : appDetail.status === 'finished'
                                ? 'badge badge-success-soft fs-2'
                                : 'badge badge-danger-soft fs-2'
                            }`}
                        >
                          {appDetail.status.toUpperCase()}
                        </span>
                      </div>
                      <div className="detail-item">
                        <strong>Booking Date:</strong>{" "}
                        {appDetail.date}
                      </div>
                    </div>
                    <div className="detail-row">
                      <div className="detail-item">
                        <strong>Slot Time:</strong>{" "}
                        {appDetail.time.start} - {appDetail.time.end}
                      </div>
                      <div className="detail-item">
                        <strong>Email:</strong> {appDetail.email}
                      </div>
                    </div>
                    <div className="detail-row">
                      <div className="detail-item">
                        <strong>Description:</strong> {appDetail.description}
                      </div>
                    </div>
                    <div className="d-flex justify-content-end button-group col-12 mt-4">
                      <button className="btn btn-outline-secondary" onClick={() => setCurrentStep(1)}> Chat</button>
                    </div>
                  </div>
                </Card.Text>
                <hr />
                <h5>Questions:</h5>
                <table className="table table-bordered mt-3">
                  <tbody>
                    <tr>
                      <th className="col-sm-8">1) Have you been feeling depressed lately?</th>
                      <td className="col-sm-4">{appDetail.firstform_depressesed === 'yes' ? 'Yes' : 'No'}</td>
                    </tr>

                    <tr>
                      <th>2) Prescribed Mental Health Medications?</th>
                      <td>{appDetail.firstform_mentalhealth === 'yes' ? 'Yes' : 'No'}</td>
                    </tr>

                    {appDetail.firstform_mentalhealth === 'yes' && (
                      <tr>
                        <td colSpan="2">
                          <strong>Medication Details:</strong>
                          <ul>
                            <li><strong>Name:</strong> {appDetail.mentalHealthDetails.name}</li>
                            <li><strong>Dosage:</strong> {appDetail.mentalHealthDetails.dosage}</li>
                            <li><strong>Frequency:</strong> {appDetail.mentalHealthDetails.frequency}</li>
                          </ul>
                        </td>
                      </tr>
                    )}

                    <tr>
                      <th>3) Psychiatric Hospitalizations History</th>
                      <td>{appDetail.firstform_psychiatric === 'yes' ? 'Yes' : 'No'}</td>
                    </tr>

                    {appDetail.firstform_psychiatric === 'yes' && (
                      <tr>
                        <td colSpan="2">
                          <strong>Medical History:</strong> {appDetail.medicalHistory}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <hr />
                <h6 className="questions-title">Forms:</h6>
                <ul className="questions-list">

                  <li className="question-item">
                    <Link
                      to={appDetail.pdfPath1}
                      className="mb-3 "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Intake Questionnaire
                    </Link>
                  </li>
                  <li className="question-item">
                    <Link
                      to={appDetail.pdfPath2}
                      className="mb-3 "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      PHQ-9 and GAD-7
                    </Link>
                  </li>
                  {appointmentStatus === 'accepted' || appointmentStatus == 'finished' ? (

                    <>
                      <li className="question-item">
                        <Link
                          to="/assets/pdf/Consent for Telehealth Consultation.pdf"
                          className="mb-3 "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Consent for Telehealth  Consultation
                        </Link>
                      </li>
                      <li className="question-item">
                        <Link
                          to="/assets/pdf/Notice of Privacy Practices.pdf"
                          className="mb-3 "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Notice of Privacy Practices
                        </Link>
                      </li>
                      <li className="question-item">
                        <Link
                          to="/assets/pdf/Practice Policies.pdf"
                          className="mb-3 "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Practice Policies
                        </Link>
                      </li>
                    </>
                  ) : ''}


                </ul>

              </Card.Body>

            </Card> : <div>No appointment found..</div>)}
        </div>
      }

      {currentStep == 1 &&
        <div className="container pb-3 mt-5 " style={{ height:"100vh" }} key={appointmentId}>
          <div className="col-lg-12 custom-col-md-12">
            <div className="row d-flex justify-content-center">
              <div className="col-md-12">
                <button
                  className="btn btn-link d-flex text-white align-items-center mb-3"
                  onClick={() => setCurrentStep(0)} // Adjust this to go to the previous step
                  style={{ textDecoration: 'none', color: '#fff' }}
                >
                  <i className="bi bi-arrow-left mr-2"></i> {/* Back Arrow Icon (Bootstrap) */}
                  Back
                </button>
                <div
                  className="card"
                  id="chat2"
                  style={{
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                  }}
                >
                  <div className="card-header d-flex justify-content-start align-items-center p-3" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.2)" }}>
                    <img
                      src="./assets/img/doctor_PNG1603412.png"
                      className="rounded-circle img-fluid img-fluid-custom "
                      alt="avatar 1"
                    />
                    <h4 className="ml-3 mb-0">Dr.Sandhya Chinala</h4>
                  </div>
                  <div className="card-body" style={{ position: "relative", height: "505px", overflow: "auto" }}>
                    {appointmentStatus === 'accepted' || appointmentStatus === 'finished' ? (
                      messages.map((msg, index) => (
                        <div key={index} className={`d-flex flex-row mb-4 ${msg.senderId === userID ? 'justify-content-end' : 'justify-content-start'}`}>
                          {/* Avatar: Doctor or User */}
                          {msg.senderId !== userID ? (
                            <img
                              src="./assets/img/doctor_PNG1603412.png"
                              className="rounded-circle img-fluid img-fluid-custom mr-2"
                              alt="Doctor Avatar"
                              style={{ width: '45px', height: '45px' }}
                            />
                          ) : null}

                          <div>
                            {/* Message Content */}
                            <p className={`small p-2 mb-1 rounded-3 ${msg.senderId === userID ? 'bg-light' : 'bg-primary text-light'}`}>
                              {msg.message}
                            </p>

                            {/* Timestamp Display */}
                            <p className="small text-muted">
                              {msg.timestamp ? new Date(msg.timestamp.seconds * 1000).toLocaleString() : ''}
                            </p>
                          </div>

                          {/* User Avatar on the right */}
                          {msg.senderId === userID && (
                            <img
                              // src={imageUrls[userID]}
                              src="/assets/img/avatar/default_avatar.png"
                              alt="User Avatar"
                              style={{ width: '45px', height: '45px' , borderRadius:'50%'  }}
                            />
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="alert alert-info text-center">
                        You will be able to chat once your appointment is accepted.
                      </div>
                    )}
                  </div>

                  {(appointmentStatus === 'accepted' || appointmentStatus === 'finished') && (
                    <div className="card-footer text-muted d-flex justify-content-start align-items-center p-3">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Type message"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                      />
                      <div className="vector-wrapper" onClick={sendMessage}>
                        <img src={vector} alt="Send" />
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default Chats;
